<template>
  <div class="registered">
    <!-- 头部 -->
    <div class="registered-top">
      <img src="../../assets/img/login/logo-h.png" alt>
      <p @click="toHome">返回首页
        <span></span>
      </p>
    </div>
    <!-- 主体 -->
    <div class="registered-body">
      <div class="registered-con">
        <!-- 表单 -->
        <div class="registered-form">
          <h2>重置你的通行证密码</h2>
          <!-- 表单组合 -->
          <div class="form-group">
            <input type="text" class="form-input" ref="inp" v-model="form.passportName" placeholder="通行证账号"
              @focus="focusInput(1)" @blur="blurInput(1)">
            <!-- 表单右侧提示 -->
            <div class="registered-model" v-show="registeredModel">
              <span></span>
              <li>英文、数字、“-”、“_”均可，长度6-16个字符</li>
            </div>
            <div class="name-wrong" v-text="nameWrong"></div>
          </div>
          <div class="form-group" style="display:flex">
            <button class="form-buttonphone">+86</button>
            <input type="text" class="form-inputphone" ref="inp4" v-model="form.passportMobile" placeholder="请输入手机号"
              @focus="focusInput(4)" @blur="blurInput(4)">
            <div class="phone-wrong" v-text="phoneWrong"></div>
          </div>
          <div class="form-group" style="display:flex">
            <input type="text" class="form-inputcode" v-model="form.smsCode" placeholder="请输入验证码">
            <button class="form-buttoncode" v-show="show" @click="showCodeModel">获取验证码</button>
            <button class="form-buttoncode" v-show="!show">{{ count }} s</button>
          </div>
          <div style="position: absolute;">
            <imgCode class="img-code" ref="imgcodeReset" @confirm="defineCode"></imgCode>
          </div>
          <div class="form-group">
            <input type="password" class="form-input" ref="inp2" v-model="form.password" maxlength="16"
              placeholder="设置你的登录密码" @focus="focusInput(2)" @blur="blurInput(2)">
            <!-- 表单右侧提示 -->
            <div class="registered-model2" v-show="registeredModel2">
              <span></span>
              <div>
                <span></span>
                <li>长度6-16个数字、大小写英文或符号任意两种以上组合</li>
                <li>请再次输入你的密码</li>
              </div>
            </div>
          </div>
          <div class="form-group">
            <input type="password" class="form-input" ref="inp3" v-model="form.verifyPassword" maxlength="16"
              placeholder="请再次输入你的密码" @focus="focusInput(3)" @blur="blurInput(3)">
          </div>
          <div class="register-wrong" v-text="wrongText"></div>
          <div class="form-group form-btn">
            <button class="form-button" @click.prevent="handlSbmit">重置密码</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="registered-footer">&reg; 2014-2019 杭州云智互联科技有限公司</div>
    <!-- 验证码模态框 -->
    <!-- <imgcode-modal ref="imgcodeReset" @confirm="defineCode"></imgcode-modal> -->
    <fade-down-modal :show="showSuccess">
      <div style="width:600px;height:210px;background:#fff;margin:0 auto;">
        <success-msg :showSuccess="showSuccess" :title="'重置密码'" :msg="'恭喜，密码重置成功！'" :msgTwo="'稍后自动跳转登录页，如未跳转，请手动点击。'">
        </success-msg>
      </div>
    </fade-down-modal>
  </div>
</template>

<script>
// import { resetUserInfoData } from '@/requests/user'
import { getfForgetSmsCode } from "@/requests/user";
import { getForgetPwd } from "@/requests/user";
import FadeDownModal from "_c/modals/fadeDown";
import successMsg from "./successMsg";
import PAGE_API from "@/apis/pageApi";
import imgCode from '_sc/imgCode'

export default {
  name: "reset",
  components: {
    FadeDownModal,
    successMsg,
    imgCode
  },
  data () {
    return {
      show: true, //显示倒计时
      count: "",
      timer: null,
      showMsg: false,
      showCode: false,
      codeModel: false, //显示验证码弹框
      registeredModel: false,
      registeredModel2: false,
      msgText: "",
      nameWrong: "",
      phoneWrong: "",
      codeWrong: "",
      showSuccess: false,
      wrongText: "",
      captcha: "",
      form: {
        passportName: "",
        password: "",
        verifyPassword: "",
        passportMobile: "",
        passport_code: "",
        smsCode: "",
        imgCode: ""
      }
    };
  },
  methods: {
    async handlSbmit () {
      this.wrongText = "";
      let nameRe = this.$validateCenter.passportNameWhds(
        this.form.passportName
      );
      if (nameRe.res == false)
      {
        this.wrongText = nameRe.msg;
        return false;
      }
      let phoneRe = this.$validateCenter.phoneNum(this.form.passportMobile);
      if (phoneRe.res == false)
      {
        this.wrongText = phoneRe.msg;
        return false;
      }
      let smsRe = this.$validateCenter.smsCode(this.form.smsCode);
      if (smsRe.res == false)
      {
        this.wrongText = smsRe.msg;
        return false;
      }
      let passwordRe = this.$validateCenter.passwordWhds(this.form.password);
      if (passwordRe.res == false)
      {
        this.wrongText = passwordRe.msg;
        return false;
      }
      let obj = {
        passportName: this.form.passportName,
        password: encodeURIComponent(this.form.password),
        passportMobile: this.form.passportMobile,
        verifyPassword: encodeURIComponent(this.form.verifyPassword),
        smsCode: this.form.smsCode
      };
      let res = await getForgetPwd(obj);
      if (res.code == 200)
      {
        this.showSuccess = true;
      } else
      {
        this.wrongText = res.msg;
      }
    },
    //边框聚焦变色
    focusInput (index) {
      if (index == 1)
      {
        this.phoneWrong = "";
        this.registeredModel = true;
      } else if (index == 2)
      {
        this.registeredModel2 = true;
      } else if (index == 3)
      {
        this.registeredModel2 = true;
      }
    },
    //失去焦点恢复颜色
    blurInput (index) {
      if (index == 1)
      {
        this.registeredModel = false;
        if (this.form.passportName == "")
        {
          this.phoneWrong = "账号不能为空";
        }
      } else if (index == 2)
      {
        this.registeredModel2 = false;
      } else if (index == 3)
      {
        this.registeredModel2 = false;
      }
    },
    //去登录页
    toLogin () {
      this.$router.push({
        path: PAGE_API.login.path
      });
    },
    //获取验证码弹框
    showCodeModel () {
      if (this.form.passportMobile == "")
      {
        this.wrongText = "手机号不能为空";
      } else if (
        this.form.passportMobile.length != 11 ||
        this.form.passportMobile[0] != 1
      )
      {
        this.wrongText = "请输入以“1”开头的十一位手机号";
      } else
      {
        // this.codeModel = true;
        this.$refs.imgcodeReset.show();
      }
    },
    // 刷新验证码
    editCaptcha () {
      this.captcha = "?" + Math.random();
    },
    //关闭验证码弹框
    closeModel () {
      this.codeModel = false;
    },
    //验证码倒计时
    countDown () {
      const TIME_COUNT = 60;
      if (!this.timer)
      {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT)
          {
            this.count--;
          } else
          {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    //确定验证码
    async defineCode (code) {
      if (code == "")
      {
        this.wrongText = "请输图形验证码";
        return false;
      }
      let obj = {
        phone: this.form.passportMobile,
        imgCode: code,
        passportName: this.form.passportName
      };
      let res = await getfForgetSmsCode(obj);
      if (res.code == 200)
      {
        // this.codeModel = false
        this.$refs.imgcodeReset.hide();
        this.countDown();
        this.editCaptcha();
      } else
      {
        this.editCaptcha();
        this.form.imgCode = "";
        this.wrongText = res.msg;
      }
    },
    toHome () {
      window.location.href = "/";
    }
  }
};
</script>

<style lang="scss">
.registered {
  width: 100%;
  height: 100vh;
  min-height: 920px;
  background-color: #f5f5f6;
  background-size: cover;
  background-position: center;
  position: relative;

  // 顶部
  .registered-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 60px;
    background-color: #f5f5f6;
    border-bottom: 1px solid #d7d8d9;

    img {
      margin-left: 30px;
      width: 124px;
      height: 30px;
    }

    p {
      margin-right: 20px;
      font-size: 15px;
      color: #383d41;
      font-weight: bold;
      cursor: pointer;

      span {
        display: block;
        float: right;
        margin-top: 4px;
        margin-left: 5px;
        width: 12px;
        height: 12px;
        background: url(../../assets/img/icon/箭头.png);
      }
    }

    p:hover {
      color: #00c2de;
    }
  }

  // 主体
  .registered-body {
    display: flex;
    justify-content: center;
    width: 100%;
    background-size: 90% 100%;
    background-position: center bottom;

    .registered-con {
      display: flex;
      justify-content: center;
      margin-top: 80px;
      width: 1000px;
      height: 530px;
      background-color: #fff;

      // 表单
      .registered-form {
        width: 320px;

        h2 {
          font-size: 30px;
          color: #373d41;
          font-weight: bold;
          line-height: 100px;
        }

        .form-group {
          width: 100%;
          padding: 10px 0;

          // 表单输入框
          .form-input {
            padding-left: 10px;
            width: 96.5%;
            height: 40px;
            font-weight: bold;
            border: 1px solid #dcdcdc;
            color: #000;
            outline: none;
            transition: all 0.7s;
          }

          .form-input:focus {
            border: 1px solid #00c2de;
          }

          // 表单按钮
          .form-button {
            width: 100%;
            height: 40px;
            font-weight: bold;
            border: none;
            outline: none;
            color: #fff;
            background-color: #0099cc;
          }

          .form-button:hover {
            background-color: #28b5d6;
          }

          .form-button:active {
            background-color: #00ccff;
          }

          // 验证码输入框
          .form-inputcode {
            padding-left: 10px;
            width: 69%;
            height: 40px;
            border: 1px solid #00c6de;
            color: #000;
            font-weight: bold;
            background-color: #ddf8fc;
          }

          // 验证码按钮
          .form-buttoncode {
            width: 29%;
            height: 42px;
            border: 1px solid #00c6de;
            background-color: #ddf8fc;
            border-left: none;
            color: #20c6e0;
            font-weight: bold;
          }

          // 手机号输入框
          .form-inputphone {
            padding-left: 10px;
            width: 78%;
            height: 40px;
            border: 1px solid #dcdcdc;
            color: #000;
            font-weight: bold;
          }

          .form-inputphone:focus {
            border: 1px solid #00c2de;
          }

          // 手机号前缀
          .form-buttonphone {
            width: 20%;
            height: 42px;
            border: 1px solid #dcdcdc;
            border-right: none;
            font-weight: bold;
            color: #989aa0;
          }

          // 表单右侧提示
          .registered-model {
            position: absolute;
            transform: translate(325px, -41px);
            width: 293px;
            height: 40px;

            span {
              position: absolute;
              transform: translate(-5px, 15px);
              display: block;
              width: 1px;
              height: 1px;
              border-width: 7px;
              border-style: solid dashed dashed;
              border-color: transparent #fff transparent transparent;
              font-size: 0;
              line-height: 0;
            }

            li {
              margin-left: 10px;
              width: 280px;
              height: 100%;
              box-shadow: 0px 0px 15px 0px rgb(116, 114, 114);
              list-style-type: disc;
              line-height: 40px;
              color: #666;
            }
          }

          .registered-model2 {
            position: absolute;
            transform: translate(325px, -41px);
            width: 293px;
            height: 40px;

            span {
              position: absolute;
              transform: translate(-5px, 15px);
              display: block;
              width: 1px;
              height: 1px;
              border-width: 7px;
              border-style: solid dashed dashed;
              border-color: transparent #fff transparent transparent;
              font-size: 0;
              line-height: 0;
            }

            div {
              margin-left: 10px;
              width: 280px;
              box-shadow: 0px 0px 15px 0px rgb(116, 114, 114);

              span {
                transform: translate(-15px, 75px);
              }

              li {
                padding: 14px 0;
                padding-left: 6px;
                width: 274px;
                height: 100%;
                list-style-type: disc;
                color: #666;
                text-align: left;
              }

              li:nth-child(2) {
                border-bottom: 1px solid #dcdcdc;
              }
            }
          }
        }
      }
    }
  }

  // 底部
  .registered-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 60px;
    background-color: #383d41;
    color: #84878c;
    text-align: center;
    line-height: 60px;
    font-size: 16px;
  }

  // 验证码模态框
  .code-model {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);

    .model-body {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 360px;
      height: 300px;
      background-color: #fff;

      h5 {
        // width: 100%;
        background: #363636;
        border-left: 8px solid #09f;
        line-height: 40px;
        color: #fff;
        text-align: left;
        padding-left: 13px;
        margin: 0;
      }

      span {
        position: absolute;
        top: 10px;
        right: 10px;
        color: #fff;
        font-size: 16px;
        cursor: pointer;
      }

      span:hover {
        color: #f00;
      }

      p {
        img {
          width: 180px;
          height: 50px;
          display: block;
          margin: 24px auto;
        }

        input {
          margin-top: 10px;
          height: 60px;
          width: 100%;
          padding: 0;
          border-radius: 0px;
          color: #333;
          font-size: 16px;
          line-height: 60px;
          border: 0px;
          border-bottom: 1px solid #a1a1a1;
          text-align: center;
        }

        button {
          width: 128px;
          margin: 0 auto;
          padding: 0;
          font-size: 18px;
          height: 40px;
          line-height: 40px;
          background: #09c;
          color: #fff;
          border: 0;
        }
      }

      .wrong {
        color: #f33;
        font-size: 14px;
        line-height: 28px;
        height: 28px;
        margin: 8px 0;
        text-align: center;
      }
    }
  }

  .register-wrong {
    position: absolute;
    // transform: translateX(-30%);
    width: 620px;
    line-height: 40px;
    text-align: left;
    color: #f00;
    font-size: 12px;
  }
}

.name-wrong {
  position: absolute;
  transform: translate(340px, -30px);
  color: #f00;
  font-size: 12px;
}

.phone-wrong {
  position: absolute;
  transform: translate(340px, 10px);
  color: #f00;
  font-size: 12px;
}

input::placeholder {
  color: rgb(161, 161, 161);
}

.form-btn {
  margin-top: 30px;
}

.img-code {
  left: 200px;
}
</style>

